import React from "react"

type Props = {
  width?: string
  height?: string
}

const Isotipo = ({ width = "18", height = "34" }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.88812 0L18 20.3269L11.2749 34H2.37431L9.08702 20.3269L0 0H8.88812Z"
        fill="url(#idisotipo)"
      />
      <defs>
        <linearGradient
          id="idisotipo"
          x1="9"
          y1="0"
          x2="9"
          y2="34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#30AB76" />
          <stop offset="1" stopColor="#71C552" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Isotipo
